/**
 * Derive a URL-friendly slug from a company name.
 *
 * Mirrors the SLUG_REGEX in packages/mission-control/src/provisioning/routes.ts:
 *   lowercase, digits + hyphens, must start/end with alphanumeric.
 *
 * The form uses this to suggest a slug as the operator types the name.
 * The operator can override; once they edit the slug field directly,
 * the auto-derivation stops for that submission.
 */
export function deriveSlug(name: string): string {
  return name
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '');
}
